export function customTypeFile() {
    let inputWrap = document.querySelectorAll(".form-group-attach");
    for (let i = 0; i < inputWrap.length; i++) {
        let el = inputWrap[i].querySelector("input");
        let label = inputWrap[i].querySelector(".label-attach span");
        el.addEventListener("change", function () {
            label.innerText = el.files[0].name;
        });
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/customTypeFile.js